/* ============================================================
   LE FÉLIN — Généalogie des races (hub) — interactivité
   Les cartes + fiches sont rendues côté serveur (Liquid). Ce JS ne fait
   QUE : révéler les cartes, dessiner la lignée au survol (desktop), et
   ouvrir/fermer les fiches. La lignée est lue depuis les data-attributs.
   ============================================================ */
(function () {
  var root = document.querySelector('.lf-gn');
  if (!root) return;
  var tree = root.querySelector('.lf-gn-tree');
  var links = root.querySelector('.lf-gn-links');
  var scrim = root.querySelector('.lf-gn-scrim');
  if (!tree || !links) return;

  var cards = Array.prototype.slice.call(tree.querySelectorAll('.lf-gn-card'));
  var parentsOf = {}, childrenOf = {};
  cards.forEach(function (c) {
    var id = c.getAttribute('data-id');
    var ps = (c.getAttribute('data-parents') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    parentsOf[id] = ps;
    ps.forEach(function (p) { (childrenOf[p] = childrenOf[p] || []).push(id); });
  });

  /* ---- reveal ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.style.transitionDelay = (en.target.dataset.d || 0) + 'ms'; en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    tree.querySelectorAll('.lf-gn-grid').forEach(function (g) {
      Array.prototype.slice.call(g.querySelectorAll('.lf-gn-card')).forEach(function (c, i) { c.dataset.d = i * 45; io.observe(c); });
    });
    setTimeout(function () { tree.querySelectorAll('.lf-gn-card:not(.in)').forEach(function (c) { c.classList.add('in'); }); }, 1400);
  } else {
    cards.forEach(function (c) { c.classList.add('in'); });
  }

  /* ---- lignée ---- */
  function up(id, acc) { (parentsOf[id] || []).forEach(function (p) { if (!acc.has(p)) { acc.add(p); up(p, acc); } }); return acc; }
  function down(id, acc) { (childrenOf[id] || []).forEach(function (c) { if (!acc.has(c)) { acc.add(c); down(c, acc); } }); return acc; }
  function family(id) { var s = new Set([id]); up(id, s); down(id, s); return s; }

  var NS = 'http://www.w3.org/2000/svg';
  // Géométrie mise en cache (mesurée une fois) → pas de reflow par survol = zéro lag.
  var geomCache = {};
  function measure() {
    var box = tree.getBoundingClientRect();
    geomCache = {};
    cards.forEach(function (c) {
      var r = c.getBoundingClientRect();
      geomCache[c.getAttribute('data-id')] = { x: r.left - box.left + r.width / 2, top: r.top - box.top, bot: r.top - box.top + r.height };
    });
  }
  function clearPaths() {
    var nodes = links.querySelectorAll('path,circle');
    for (var i = 0; i < nodes.length; i++) nodes[i].remove();
  }
  function drawFamily(set) {
    if (!Object.keys(geomCache).length) measure();
    clearPaths();
    var dots = {};
    set.forEach(function (id) {
      (parentsOf[id] || []).forEach(function (pid) {
        if (!set.has(pid)) return;
        var a = geomCache[pid], b = geomCache[id]; if (!a || !b) return;
        var x1 = a.x, y1 = a.bot, x2 = b.x, y2 = b.top, dy = Math.max(30, (y2 - y1) * 0.42);
        var path = document.createElementNS(NS, 'path');
        path.setAttribute('d', 'M ' + x1 + ' ' + y1 + ' C ' + x1 + ' ' + (y1 + dy) + ', ' + x2 + ' ' + (y2 - dy) + ', ' + x2 + ' ' + (y2 - 6));
        path.setAttribute('marker-end', 'url(#lfgn-arrow)');
        links.appendChild(path);
        dots[x1 + ',' + y1] = 1;
      });
    });
    Object.keys(dots).forEach(function (k) {
      var xy = k.split(','), c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', xy[0]); c.setAttribute('cy', xy[1]); c.setAttribute('r', '4'); links.appendChild(c);
    });
  }
  var cur = null;
  function focusBreed(id) {
    if (cur === id) return; cur = id;
    var set = family(id); tree.classList.add('focusing');
    cards.forEach(function (c) { var on = set.has(c.getAttribute('data-id')); c.classList.toggle('lit', on); c.classList.toggle('root', c.getAttribute('data-id') === id); });
    drawFamily(set);
  }
  function clearFocus() {
    if (cur === null) return; cur = null; tree.classList.remove('focusing');
    cards.forEach(function (c) { c.classList.remove('lit', 'root'); });
    while (links.firstChild) links.removeChild(links.firstChild);
  }
  var noHover = window.matchMedia && window.matchMedia('(hover:none)').matches;
  if (!noHover) {
    cards.forEach(function (c) { c.addEventListener('mouseenter', function () { focusBreed(c.getAttribute('data-id')); }); });
    tree.addEventListener('mouseleave', clearFocus);
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); if (cur) drawFamily(family(cur)); }, 150); });
    window.addEventListener('load', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  /* ---- fiches ---- */
  var openEl = null, lastFocus = null;
  function ficheOf(id) { return root.querySelector('#lf-gn-fiche-' + id); }
  function open(id, trigger) {
    var f = ficheOf(id); if (!f) return;
    if (openEl && openEl !== f) { openEl.classList.remove('open'); openEl.hidden = true; }
    lastFocus = trigger || document.activeElement;
    f.hidden = false; f.scrollTop = 0; void f.offsetWidth; f.classList.add('open');
    if (scrim) scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    openEl = f;
    var c = f.querySelector('.lf-gn-fclose'); if (c) c.focus({ preventScroll: true });
    f.scrollTop = 0;
  }
  function close() {
    if (!openEl) return;
    openEl.classList.remove('open');
    var f = openEl; setTimeout(function () { if (!f.classList.contains('open')) f.hidden = true; }, 500);
    if (scrim) scrim.classList.remove('open');
    document.body.style.overflow = '';
    openEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  tree.addEventListener('click', function (e) { var c = e.target.closest('.lf-gn-card'); if (c) open(c.getAttribute('data-id'), c); });
  tree.addEventListener('keydown', function (e) {
    var c = e.target.closest('.lf-gn-card'); if (!c) return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(c.getAttribute('data-id'), c); }
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('.lf-gn-fclose')) { close(); return; }
    var go = e.target.closest('[data-go]'); if (go) { e.preventDefault(); open(go.getAttribute('data-go'), go); }
  });
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
